export default "__VITE_ASSET__BmeXzR1Q__"